import { AbstractControl } from '@angular/forms';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export function arrivalFromBeforeArrivalThroughValidator(
	control: AbstractControl,
): {
	arrivalFromBeforeArrivalThrough: {
		message: string;
	};
} | null {
	const { arrivalThrough, arrivalFrom } = control.value;
	// avoid displaying the message error when values are empty
	if (!arrivalThrough || !arrivalFrom) {
		return null;
	}

	const from = dayjs(arrivalFrom, 'DD-MM-YYYY');
	const through = dayjs(arrivalThrough, 'DD-MM-YYYY');

	if (from.isBefore(through) || from.isSame(through)) {
		return null;
	}

	return {
		arrivalFromBeforeArrivalThrough: { message: 'from-not-before-through' },
	};
}
